module.exports = __webpack_public_path__ + "img/gh-31501____-58.prt.1ba76d8e.jpg";